__turbopack_context__.v({
  "scheduleLabel": "showschedule-module-scss-module__HFzNOG__scheduleLabel",
  "scheduleSlot": "showschedule-module-scss-module__HFzNOG__scheduleSlot",
  "scheduleTimeBlock": "showschedule-module-scss-module__HFzNOG__scheduleTimeBlock",
  "scheduleTimeGroup": "showschedule-module-scss-module__HFzNOG__scheduleTimeGroup",
  "scheduleTimeRow": "showschedule-module-scss-module__HFzNOG__scheduleTimeRow",
  "scheduleTitle": "showschedule-module-scss-module__HFzNOG__scheduleTitle",
  "showSchedule": "showschedule-module-scss-module__HFzNOG__showSchedule",
});
